import apiClient, {errorConsole} from '../apiClient';

const authServices = {
  signIn: async (datos) => {
    try {
      const response = await apiClient.post(`/auth/login`, {email: datos.email, password: datos.password });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  signInPhantom: async (datos) => {
    try {
      const response = await apiClient.post(`/auth/login_phantom`, {email: datos.email, phantom: datos.phantom });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  checkSignIn: async () => {
    //TODO: verificar que los admin puedan modificar cualquier usuario y los postulanes solo su informacion
    try {
      const response = await apiClient.post(`/auth/checkSignIn`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  signUp: async (datos) => {
    try {
      const copiaUsuario = {...datos}
      copiaUsuario.preferencias_usuario_attributes = copiaUsuario.preferencias_usuario
      delete copiaUsuario.preferencias_usuario

      const response = await apiClient.post(`/auth/signUp`, {registro: copiaUsuario});
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  signInGoogle: async (token, datosUsuario = {}) => {
    try {
      const params = datosUsuario
      params.token = token
      const response = await apiClient.post(`/auth/signInGoogle`, params);
      return response.data;
    } catch (error) {
      console.log(error)
      throw error;
    }
  },
};

export default authServices;
